<template>
    <div class="container-fluid content mt-3 mt-md-0" v-if="emblem">
        <!-- Header mit Navigation -->
        <sakali-header title="Wappen-Editor"/>
        <div class="row mt-3"
             v-if="emblemSVG">
            <div class="col-5 text-center">
                <div v-html="emblemSVG"/>
            </div>
            <div class="col-7 text-center mt-2">
                <button class="btn btn-small btn-sakali"
                        @click="save"
                        :disabled="!emblem.editable">
                    Speichern
                </button>
                <p class="small mt-1" v-if="emblem.editable">
                    Achtung: Du kannst nur einmal pro Saison Dein Vereinswappen ändern!
                </p>
                <p class="mt-1 text-warning" v-if="!emblem.editable">
                    Du hast Dein Wappen in dieser Saison bereits geändert.
                </p>
            </div>
        </div>
        <emblem-editor
                :emblem="emblem"
                :emblemSVG="emblemSVG"
                :emblemShapes="emblemShapes"
                @emblem-change="refreshEmblem(emblem)"/>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import sakaliApi from "../sakali-api";
    import EmblemEditor from "../components/team/EmblemEditor";
    import {mapActions} from 'vuex';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        data() {
            return {
                team: null,
                emblem: null,
                emblemSVG: null,
                emblemShapes: null,
                isLoading: false
            }
        },
        methods: {
            ...mapActions(['messageAction', 'handleErrorAction']),
            loadEmblemShapes() {
                sakaliApi.get('/emblem-shapes', {
                    params: {
                        size: 27
                    }
                }).then(e => {
                    this.emblemShapes = e.data;
                })
            },
            loadEmblem() {
                sakaliApi.get('/emblems', {
                    params: {
                        team: this.team.id,
                        size: 120,
                    }
                }).then(e => {
                    this.emblem = e.data;
                })
            },
            refreshEmblemSVG() {
                sakaliApi.post('/emblem-img', this.emblem, {
                    headers: {
                        Accept: 'image/svg+xml'
                    }
                }).then(e => {
                    this.emblemSVG = e.data;
                })
            },
            refreshEmblem(e) {
                this.emblem = e;
                this.refreshEmblemSVG();
            },
            save() {
                this.isLoading = true;
                sakaliApi.post('/emblems/' + this.team.id, this.emblem)
                    .then(res => {
                        this.emblem = res.data;
                        this.messageAction({
                            message: "Du hast Dein Team-Wappen geändert.",
                            type: "success"
                        });
                    })
                    .catch(error => {
                        this.handleErrorAction(error);
                    })
                    .finally(() => {
                            this.isLoading = false;
                        }
                    );
            }
        },
        components: {
            EmblemEditor, Loading
        },
        watch: {
            emblem() {
                this.refreshEmblemSVG();
            }
        },
        mounted() {
            this.loadEmblemShapes();
            this.team = this.$route.query.team;
            if (!this.team)
                this.team = this.$store.getters.team;
            this.loadEmblem()
        }
    }
</script>
